import { Injectable } from '@angular/core';
import * as Papa from 'papaparse';

@Injectable({ providedIn: 'root' })
export class ImportCsvService {
  public async importCsvFile(file: any) {
    let result = await new Promise(resolve => {
      const reader = new FileReader();

      reader.onload = function (e) {
        const deserializeRow = (row: any, delimiter = ',') => {
          const values = [];
          let index = 0,
            matchStart = 0,
            isInsideQuotations = false;
          while (true) {
            if (index === row.length) {
              values.push(row.slice(matchStart, index));
              break;
            }
            const char = row[index];
            if (char === delimiter && !isInsideQuotations) {
              values.push(
                row
                  .slice(matchStart, index)
                  .replace(/^"|"$/g, '')
                  .replace(/""/g, '"')
                  .replace(/\\n/g, '\n')
              );
              matchStart = index + 1;
            }
            if (char === '"')
              if (row[index + 1] === '"') index += 1;
              else isInsideQuotations = !isInsideQuotations;
            index += 1;
          }
          return values;
        };

        function csvToArray(data: string) {
          const rows = data.split('\r\n').filter(o => o.length > 0);
          return rows.map(row => deserializeRow(row));
        }

        let csvArray = csvToArray(e.target!.result!.toString());

        const colCount = csvArray[0].length;

        // Get rows that with less or more columns than the first row
        const rowWithMoreColumns = csvArray.filter(o => o.length > colCount);
        // Remove extra column values
        rowWithMoreColumns.forEach(row => {
          row.splice(colCount);
        });

        const rowWithLessColumns = csvArray.filter(o => o.length < colCount);
        // Add empty columns to rows with less columns
        rowWithLessColumns.forEach(row => {
          while (row.length < colCount) {
            row.push('');
          }
        });

        // csvArray = csvArray.filter(o => o.length === csvArray[0].length);
        resolve(csvArray);
      };

      reader.readAsText(file);
    });

    return result;
  }

  // Read CSV file using papa parse
  public parseCsvFile(
    file: File | null,
    headerRowNumber: number = 0,
    customHeaders: string[] = []
  ): Promise<any[]> {
    if (!file) {
      return new Promise(() => []);
    }

    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        skipEmptyLines: true,
        complete: (results: any) => {
          const csvArray = results.data;

          // Use the specified header row to determine column names
          let headers = csvArray[headerRowNumber];
          for (let index = 0; index < headers.length; index++) {
            const element = headers[index];
            if (!element && customHeaders.length > index) {
              headers[index] = customHeaders[index];
            }
          }

          let dataRows: any[] = csvArray.slice(headerRowNumber + 1);
          // Pad each data row with empty values to match the header length

          dataRows = dataRows.map(row => {
            while (row.length < headers.length) {
              row.push(''); // Add empty values
            }
            return row;
          });
          dataRows = dataRows.filter(p => p.length === headers.length);

          resolve([headers, ...dataRows]);
        },
        error: (error: any) => {
          reject(error);
        }
      });
    });
  }
}
